import {Vector2} from "three";

export default class PointerManager {
    position = {
        screen: { x: 0, y: 0, },
        canvas: { x: 0, y: 0, },
        canvasNormalized: new Vector2(),
    };

    updatePointerPosition(clientX, clientY, canvasWidth, canvasHeight, leftOffset, topOffset) {
        let x, y;

        x = ((clientX - leftOffset) / canvasWidth) * 2 - 1;
        y = -((clientY - topOffset) / canvasHeight) * 2 + 1;

        this.position.canvasNormalized.setX(x);
        this.position.canvasNormalized.setY(y);

        x = (clientX - leftOffset) / canvasWidth;
        y = (clientY - topOffset) / canvasHeight;

        this.position.canvas = { x, y };

        x = clientX / window.innerWidth;
        y = clientY / window.innerHeight;

        this.position.screen = { x, y };
    }
}